// Rolldown 1.x doesn't unwrap module.exports.default for CJS packages that set __esModule
// via webpack's n.r() helper. Import the CJS file directly (bypassing the alias) and
// re-export as proper ESM so all consumers use a plain default import.
import _Datetime from 'react-datetime/dist/react-datetime.cjs.js'

export default (_Datetime as unknown as { default?: typeof _Datetime }).default ?? _Datetime
